import { cn } from '@playbooks/ui/lib/utils';

type SpinnerProps = React.ComponentProps<'span'>;

const Spinner = ({ className, ...props }: SpinnerProps) => {
	// Theme
	const rootClassName = cn(
		'inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent',
		className,
	);

	// Render
	return <span data-slot='spinner' role='status' aria-label='Loading' className={rootClassName} {...props} />;
};

export { Spinner };
